import { createSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';
import SubscriptionTypes from 'constants/SubscriptionTypes';
const {
    SUBSCRIPTION_TYPES: { AUTO_REPLENISHMENT }
} = SubscriptionTypes;

/**
 * Selector that returns Auto Replenishment subscription counts from `user.subscriptionSummary`.
 */
const arProfileSubCountsSelector = createSelector(userSelector, user => {
    const subscriptionSummary = user?.subscriptionSummary || [];
    const autoReplenishmentSubscriptions = subscriptionSummary.find(subscription => subscription.type === AUTO_REPLENISHMENT);

    return {
        active: autoReplenishmentSubscriptions?.active ?? 0,
        paused: autoReplenishmentSubscriptions?.paused ?? 0,
        cancelled: autoReplenishmentSubscriptions?.cancelled ?? 0
    };
});

export { arProfileSubCountsSelector };
